import { Grid, Radio, VStack } from '@chakra-ui/react'
import { RadioGroupFormControl } from 'BrokerTsLib/src/components'
import type { InsuranceParamsDto } from 'BrokerTsLib/src/dtos'
import { Risk, RiskVariant } from 'BrokerTsLib/src/enums'
import { useFormContext } from 'BrokerTsLib/src/rhf'
import { useEffect } from 'react'

import { useGetRiskVariants } from '@/hooks'
import Car from '@/images/car.svg?react'
import CarCrash from '@/images/carCrash.svg?react'
import CarPercent from '@/images/carPercent.svg?react'

function VariantSelectionRadio({
  isDisabled = false,
}: {
  isDisabled?: boolean
}) {
  const { setValue, watch, control } = useFormContext<InsuranceParamsDto>()

  const { data: dataPov } = useGetRiskVariants(Risk.POV)
  const { data: dataHav } = useGetRiskVariants(Risk.HAV)
  const { data: dataSpol } = useGetRiskVariants(Risk.SPOL)

  const vehiclePrice = watch('vehicle.price')
  useEffect(() => {
    if (!vehiclePrice) setValue('baseParams.hav', [RiskVariant.WithoutHAV])
  }, [vehiclePrice])

  const havArray = watch('baseParams.hav') ?? []
  const hav = havArray.length > 0 ? havArray[0] : RiskVariant.WithoutHAV

  useEffect(() => {
    if (hav === RiskVariant.WithoutHAV) setValue('baseParams.spol', [])
  }, [hav])

  return (
    <Grid
      sx={{
        w: '100%',
        gridTemplateColumns: {
          md: 'repeat(2, 1fr)',
          lg: 'repeat(3, 1fr)',
        },
        gap: 8,
        alignItems: 'start',
        justifyContent: 'space-between',
      }}
    >
      <RadioGroupFormControl
        name="baseParams.pov"
        label="Povinné ručení (mil. Kč)"
        labelProps={{ icon: <Car /> }}
        gap={8}
        isDisabled={isDisabled}
        control={control}
        valueAsNumber
        valueAsArray
      >
        <RadioStack>
          {dataPov?.data.map((item) => (
            <Radio value={item.id.toString()} key={item.id}>
              {item.name}
            </Radio>
          ))}
        </RadioStack>
      </RadioGroupFormControl>

      <RadioGroupFormControl
        name="baseParams.hav"
        label="Havarijní pojištění"
        labelProps={{
          icon: <CarCrash />,
          hint:
            !vehiclePrice &&
            'Pro výběr havarijního pojištění je potřeba vyplnit PČ vozidla.',
          hintType: 'warning',
        }}
        gap={8}
        isDisabled={!vehiclePrice || isDisabled}
        control={control}
        valueAsNumber
        valueAsArray
      >
        <RadioStack>
          {dataHav?.data
            .filter((x) => x.id != RiskVariant.Package)
            .map((item) => (
              <Radio value={item.id.toString()} key={item.id}>
                {item.name}
              </Radio>
            ))}
        </RadioStack>
      </RadioGroupFormControl>

      <RadioGroupFormControl
        name="baseParams.spol"
        label="Spoluúčast"
        labelProps={{ icon: <CarPercent /> }}
        gap={8}
        isDisabled={hav === RiskVariant.WithoutHAV || isDisabled}
        control={control}
        valueAsNumber
        valueAsArray
      >
        <RadioStack>
          {dataSpol?.data.map((item) => (
            <Radio value={item.id.toString()} key={item.id}>
              {item.name.replace('Spoluúčast', '')}
            </Radio>
          ))}
        </RadioStack>
      </RadioGroupFormControl>
    </Grid>
  )
}

const RadioStack = ({ children }: { children: React.ReactNode }) => (
  <VStack ml={2} align="start" gap={3}>
    {children}
  </VStack>
)

export default VariantSelectionRadio
